<template>
  <recipe-page :event="page">
    <template v-slot:footer>
      <v-container fluid class="text-center">
        <print>Print this recipe</print>
      </v-container>
      <v-container fluid>
        <v-divider class="my-4"></v-divider>
      </v-container>
      <v-container fluid>
        <v-row align="center" justify="center">
          <ul class="posted-under text-center">
            <li>Posted under</li>
            <li
              v-for="(tag, index) in page.tags"
              :key="index"
            >
              <v-btn
                small
                text
                :to="`/blog?search=${encodeURIComponent(tag)}`"
              >
                {{tag}}
              </v-btn>
            </li>
          </ul>
        </v-row>
      </v-container>
      <v-container fluid>
        <v-divider class="my-4"></v-divider>
      </v-container>
      <v-container fluid>
        <v-row data-aos="fade">
          <email-group-sign-up></email-group-sign-up>
        </v-row>
      </v-container>
      <v-container fluid>
        <v-divider class="my-4"></v-divider>
      </v-container>
      <v-container fluid>
        <v-row data-aos="fade">
          <you-may-also-like
            :pageId="page.id"
            :tags="page.tags"
          ></you-may-also-like>
        </v-row>
      </v-container>
      <v-container fluid>
        <v-divider class="my-4"></v-divider>
      </v-container>
      <comments :page="page"></comments>
      <instagram-follow></instagram-follow>
    </template>
  </recipe-page>
</template>

<script>
import {
  VBtn,
  VContainer,
  VDivider,
  VRow,
} from 'vuetify/lib'
import moment from 'moment'

import Comments from '@/components/Comments'
import EmailGroupSignUp from '@/components/EmailGroupSignUp'
import InstagramFollow from '@/components/InstagramFollow'
import RecipePage from '@/components/RecipePage'
import YouMayAlsoLike from '@/components/YouMayAlsoLike'
import MetaInfoBuilder from '@/utils/social'
import Print from '@/components/Print'
import {PageDocument} from '@/utils/types'


export default {
  components: {
    Comments,
    EmailGroupSignUp,
    InstagramFollow,
    Print,
    RecipePage,
    VBtn,
    VContainer,
    VDivider,
    VRow,
    YouMayAlsoLike,
  },
  created() {
    this.fetchPage()
  },
  data: () => ({
    loading: false,
    page: null,
  }),
  metaInfo() {
    if (this.page) {
      return new MetaInfoBuilder()
        .description(this.page.title)
        .image(this.page.image)
        .title(this.page.title)
        .build()
    }
  },
  methods: {
    fetchPage() {
      this.loading = true
      this.$bind('page', PageDocument.Collection.doc(this.pageId))
        .then(() => this.loading = false)
    },
    postedAt(timestamp) {
      return moment(timestamp.toDate()).format('DD MMM YYYY')
    },
  },
  watch: {
    '$route': 'fetchPage',
  },
  props: {
    pageId: String
  }
}
</script>

<style lang="scss" scoped>
.page-section {

  font-size: 15px;

  h6 {
    border: 1px solid;
    display: inline-block;
    font-size: 12px;
    padding: 6px 18px;
    margin-bottom: 20px;
    text-transform: uppercase;
    word-break: normal;
    font-weight: normal;
  }

  .posted-on {
    font-size: 12px;
    text-transform: uppercase;
  }

  .posted-under {
    font-size: 15px;
    list-style: none;
    padding: 0;

    li:first-child {
      color: gray;
    }

    li {
      display: inline-block;
      margin: 0 5px;
    }
  }
}
</style>
